import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import Select from 'react-select';
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import { reactSelectStyles } from '../helpers/utils.js';

class EMISchemeFilter extends Component {
    state = {
         emiSchemeLists:[],
         emiSchemeValue:'',
    };
    componentDidMount(){
        this._getEmiScheme(this.props.start_date,this.props.end_date, this.props.is_current_date);
    }

    resetEMISchemeFilter(){
        this.setState({
        emiSchemeValue: [],
        })
    }
     _getEmiScheme(start_date, end_date, is_current_date){
        axios.post(config.get('API_URL')+'/reports/get-emi-scheme-filter/',{
                yestSend:start_date,
                todSend:end_date,
                is_current_date: is_current_date
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {
            if(Array.isArray(response.data) && response.data.length) {
                response.data.map((scheme, index) => {
                    this.state.emiSchemeLists.push({value: scheme.scheme, label: scheme.scheme})
                });
            }
        });
    }
    changeEmiScheme(optionSelected){
        let value='';
        let schemeArray = [];
        if(optionSelected.length < 1){
            value = null;
            schemeArray = '';
        }
        else{
            optionSelected.map((mids, i) => {
                schemeArray.push(mids.value)
                var index = this.state.emiSchemeLists.findIndex(obj => obj.value==mids.value);
                this.state.emiSchemeLists.move(index,0).join(',');
            });
        }
        this.props.onSelectEMIScheme(optionSelected, schemeArray);
        this.setState({
            emiSchemeValue:optionSelected,
        });
    }

    render() {

        return (
            <ReactMultiSelectCheckboxes name="emi_scheme"
            isMulti
            value={this.state.emiSchemeValue}
            styles={reactSelectStyles} className="report-listbox"
            isClearable={false}
            onChange={this.changeEmiScheme.bind(this)}
            options={this.state.emiSchemeLists}
            placeholderButtonLabel="Select [ EMI Scheme]"
        />
      );

    }
}
export default EMISchemeFilter;